












import { Component, Vue, Prop } from "vue-property-decorator";

import { Dialog, Notify } from "vant";
import EditCategory from "@/components/modals/EditCategory.vue";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {},
})
export default class SingleConvCategory extends Vue {
  @Prop() item!: any;
}
